module.exports = __webpack_public_path__ + "static/Postmates-2ab7aec7d22886dc37ca70aa1e32a2f6.jpg";